import { TableCol, TableRowItem, TableSort } from '../component'

export function sortedRows<T>(
  rows: TableRowItem<T>[],
  cols?: TableCol<T>[],
  sort?: TableSort,
  locale?: string,
): TableRowItem<T>[] {
  const colKeys = cols?.map((col) => col.key) || Object.keys(rows[0]?.data || {})
  const sortField = sort?.field || colKeys[0]
  return rows.sort((a, b) => {
    const colIndex = colKeys.indexOf(sortField)
    const colSort = cols?.[colIndex]?.sort
    if (colSort) {
      return colSort(a.data, b.data) * (sort?.direction === 'desc' ? -1 : 1)
    }
    const aVal = (a.data as Record<string, string | number>)?.[sortField]
    const bVal = (b.data as Record<string, string | number>)?.[sortField]
    if (typeof aVal === 'string' && typeof bVal === 'string') {
      return (
        aVal.localeCompare(bVal, locale, {
          numeric: true,
          sensitivity: 'base',
        }) * (sort?.direction === 'desc' ? -1 : 1)
      )
    } else if (typeof aVal === 'number' && typeof bVal === 'number') {
      return (aVal - bVal) * (sort?.direction === 'desc' ? -1 : 1)
    } else
      return (
        `${aVal}`.localeCompare(`${bVal}`, locale, {
          numeric: true,
          sensitivity: 'base',
        }) * (sort?.direction === 'desc' ? -1 : 1)
      )
  })
}
